/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import { Chart as ChartJS, BarElement, Tooltip } from "chart.js";
import { Chart } from "react-chartjs-2";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import st_colors from "../../Data/twenty_colors.json";

/*CONST*/
ChartJS.register(BarElement, Tooltip);

class RANGKING_CHART_MANUAL extends Component {
  state = {};

  scoring = (totalRank) => {
    // Buat copy array dan urutkan secara descending
    const sorted = [...totalRank].sort((a, b) => b - a);

    // Mapping setiap elemen ke ranking berdasarkan posisi di array terurut
    return totalRank.map((item) => sorted.indexOf(item) + 1);
  };

  render() {
    const hbu_alternative_array = this.props.hbu_alternative_array || [];

    // Map colors using the modulo operation
    const backgroundColors = hbu_alternative_array.map(
      (_, index) => st_colors[index % st_colors.length]
    );

    const hoverBackgroundColors = backgroundColors.map(
      (color) => color.replace("1)", "0.8)") // Adjust for transparency if the color is rgba, otherwise leave as-is.
    );

    const chart_data = {
      labels: hbu_alternative_array.map((item) => item.JENIS),
      datasets: [
        {
          label: "Result Scores",
          data: this.scoring(
            hbu_alternative_array.map((item) => item.total_rank)
          ),
          backgroundColor: backgroundColors,
          hoverBackgroundColor: hoverBackgroundColors,
        },
      ],
    };

    const chart_options = {
      responsive: true,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              return `${tooltipItem.label}: ${tooltipItem.raw}`;
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            display: false, // Turn off x-axis labels
          },
        },
      },
    };

    // Generate legend content
    const legend_content = (
      <ul
        style={{ listStyleType: "none", padding: 0 }}
        className="marginLeft_30 flex gap_10 wrap"
      >
        {chart_data.labels.map((label, index) => (
          <li
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "16px",
                height: "16px",
                backgroundColor: backgroundColors[index],
                marginRight: "8px",
                borderRadius: "50%",
              }}
            ></span>
            <p className="text_small">{label}</p>
          </li>
        ))}
      </ul>
    );

    return (
      <main className="flex gap_20 wrap align_start">
        <section className="center_perfect w_full">
          <div>
            <Chart type="bar" data={chart_data} options={chart_options} />
          </div>
        </section>
        <section className="margin_bottom center_perfect w_full">
          <div>
            <h4 className="margin_bottom marginLeft_30">Legend</h4>
            {legend_content}
          </div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(RANGKING_CHART_MANUAL);
